module.exports = __webpack_public_path__ + "static/media/FullLogo_Noclearspace.ddd2e3de.svg";